import checkRealtimeSocketConnection from 'actions/CheckRealtimeSocketConnection';

import { StudioLogger } from '@studio/logger/StudioLogger';
import { clearNotification, showModal } from 'actions';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/ModalTypes';
import { REALTIME_CONNECTION_TIMEOUT_VALUE } from '../../../constants';
const LOG = new StudioLogger('SocketDispatcher');

/**
 * Sets up the socket 'disconnect' event handler.
 * When the socket disconnects, it clears notifications, sets a timeout to show
 * a connection lost modal if reconnection doesn't occur within the timeout period,
 * logs the disconnection event, and dispatches a realtime connection check.
 *
 * @param {Object} socket - The socket.io socket instance
 * @param {Object} store - The Redux store instance
 * @returns {void}
 */
const socketDisconnected = (socket, store) => {
  socket.on('disconnect', () => {
    LOG.error(`Socket disconnected. Attempting to reconnect...`);
    store.dispatch(clearNotification());
    if (!globalThis.realtimeConnectionLostTimeout) {
      globalThis.realtimeConnectionLostTimeout = setTimeout(() => {
        store.dispatch(clearNotification());
        store.dispatch(showModal(LOST_REALTIME_SOCKET_CONNECTION, null));
      }, REALTIME_CONNECTION_TIMEOUT_VALUE);
    }

    const {
      meeting: { attendeeResponse }
    } = store.getState();
    const payload = {
      attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
    };
    LOG.error('Realtime connection lost', payload);
  });

  store.dispatch(checkRealtimeSocketConnection());
};

export { socketDisconnected };
